<div class="energy-compass-table-view" style="flex: 1 1 auto;">
    <table *ngIf="visible" #visibleTable class="table m-0 align-middle" [class.comparison-table]="comparisonActive">
        <ng-container *ngIf="_data">
            <thead>
            <tr *ngIf="!comparisonActive">
                <th>Location</th>
                <th>Calculation year</th>
                <th>WEii class</th>
                <th>WEii score</th>
                <th>Energy label</th>
            </tr>
            <tr *ngIf="comparisonActive">
                <th>Location</th>
                <th>Years</th>
                <th>WEii score</th>
                <th>Compared WEii score</th>
                <th>Difference</th>
            </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of visibleRows; trackBy: trackBy">
                    <td class="text-start notranslate">{{row.locationName}}</td>
                    <ng-container *ngIf="!comparisonActive">
                        <td class="notranslate">{{row.calculationYear}}</td>
                        <td>{{row.weiiClass}}</td>
                        <td class="notranslate" [ngClass]="{'text-danger': row.value > row.parisProofValue, 'text-success': row.value <= row.parisProofValue}">
                            {{row.value | number:'1.1-1'}} kWh/m²
                        </td>
                        <td class="notranslate">{{row.energyLabel || '–'}}</td>
                    </ng-container>
                    <ng-container *ngIf="comparisonActive">
                        <td class="notranslate">{{row.calculationYear}} vs {{row.comparison?.calculationYear || '–'}}</td>
                        <td class="notranslate">{{row.value | number:'1.1-1'}} kWh/m²</td>
                        <td class="notranslate">{{row.comparison?.value | number:'1.1-1'}} kWh/m²</td>
                        <td class="notranslate" [ngClass]="{'text-success': row.delta < 0, 'text-danger': row.delta > 0}">
                            {{row.delta | number:'1.1-1'}} kWh/m²
                            <small class="d-block">{{row.deltaPercentage | percent:'1.1-1'}}</small>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
    </table>

    <table *ngIf="renderExportTable" #table class="d-none">
        <ng-container *ngIf="_data">
            <thead><tr>
                <th>Location</th><th>Calculation year</th><th>Building type</th><th>WEii class</th>
                <th>Energy label</th><th>WEii score (kWh/m²)</th><th>Paris Proof (kWh/m²)</th>
                <th>Calculation variant</th><th>Calculation period start</th><th>Calculation period end</th>
                <th>Reference weather station</th><th>Weather station code</th><th>Standard WEii</th>
                <th>Climate normalized WEii</th><th>Climate normalization applied</th><th>Climate degree days</th>
                <th>Reference degree days</th><th>Heating share assumption</th><th>Climate correction factor</th>
                <th>Climate correction (kWh)</th><th>Normalized gas component (kWh)</th><th>Normalized heat component (kWh)</th>
                <th>Gross electricity production (kWh)</th><th>Directly self-consumed electricity (kWh)</th>
                <th>Net electricity consumption (kWh)</th><th>Adjusted electricity component (kWh)</th>
                <th>Excluded charging consumption (kWh)</th><th>Full-electric</th><th>Excluded gas (m³)</th>
                <th>Excluded heat (GJ)</th><th>Excluded cooling (GJ)</th><th>Area (m²)</th>
                <th>Heat (GJ)</th><th>WEii heat weight</th><th>Weighted heat (kWh)</th>
                <th>Cooling (GJ)</th><th>WEii cooling weight</th><th>Weighted cooling (kWh)</th>
            </tr></thead>
            <tbody>
                <tr *ngFor="let row of exportRows; trackBy: trackBy">
                    <td class="notranslate">{{row.locationName}}</td><td>{{row.calculationYear}}</td>
                    <td>{{row.buildingTypeName}}</td><td>{{row.weiiClass}}</td><td>{{row.energyLabel}}</td><td>{{row.value}}</td>
                    <td>{{row.parisProofValue}}</td><td>{{row.calculationVariant}}</td><td>{{row.calculationPeriodStart}}</td>
                    <td>{{row.calculationPeriodEnd}}</td><td>{{row.weatherStationName}}</td><td>{{row.weatherStationCode}}</td>
                    <td>{{row.standardWeii}}</td><td>{{row.climateNormalizedWeii}}</td><td>{{row.climateNormalizationApplied ? 'Yes' : 'No'}}</td>
                    <td>{{row.climateDegreeDays}}</td><td>{{row.climateReferenceDegreeDays}}</td><td>{{row.climateHeatingShare}}</td>
                    <td>{{row.climateCorrectionFactor}}</td><td>{{row.climateCorrectionKwh}}</td><td>{{row.normalizedGasKwh}}</td>
                    <td>{{row.normalizedHeatKwh}}</td><td>{{row.grossProductionKwh}}</td><td>{{row.directlySelfConsumedElectricityKwh}}</td>
                    <td>{{row.netElectricityKwh}}</td><td>{{row.adjustedElectricityKwh}}</td><td>{{row.excludedEvKwh}}</td>
                    <td>{{row.fullElectric ? 'Yes' : 'No'}}</td><td>{{row.excludedGasM3}}</td><td>{{row.excludedHeatGj}}</td>
                    <td>{{row.excludedColdGj}}</td><td>{{row.area}}</td>
                    <td>{{row.heatGj}}</td><td>{{row.heatWeight}}</td><td>{{row.weightedHeatKwh}}</td>
                    <td>{{row.coldGj}}</td><td>{{row.coldWeight}}</td><td>{{row.weightedColdKwh}}</td>
                </tr>
            </tbody>
        </ng-container>
    </table>
</div>
